const getters = {
    getProductionRecipeLijst: (state) => {
        return state.prodRecipeInfoLijst;
    },
    getIngredientProductionInfo: (state) => {
        return state.prodIngrProdInfoLijst;
    }
};

export default getters;
